(function() { module.exports = window["dayjs"]; }());